import React, { useRef, useState } from 'react';
import QRCode from 'qrcode.react';
import { Image, Header, Input, Segment } from 'semantic-ui-react';

const CurrentPageQR = ({ titleProp, qrSize, showTitleInput, showTitle, float, logoImagePath }) => {
  const [title, setTitle] = useState(titleProp ? titleProp : '');
  const componentRef = useRef();

  const handleTitleInputChange = e => {
    setTitle(e.target.value);
  };

  return (
    <Segment textAlign="center" basic className="notPaddedSegment">
      <ComponentToPrint
        ref={componentRef}
        title={title}
        qrSize={qrSize}
        showTitle={showTitle}
        float={float}
        logoImagePath={logoImagePath}
      />
      {showTitleInput && (
        <div>
          <Input
            placeholder="Title"
            onChange={handleTitleInputChange}
            value={title}
            style={{ marginTop: '5px', marginBottom: '10px' }}
            icon="edit"
            maxLength={25}
          />
        </div>
      )}
      {/*<div>
        <ReactToPrint
          style={{ marginTop: '-10px', marginBottom: '10px' }}
          trigger={() => <Button icon="print" />}
          content={() => componentRef.current}
        />
      </div>*/}
    </Segment>
  );
};

class ComponentToPrint extends React.Component {
  render() {
    const { showTitle, qrSize, title, float, logoImagePath } = this.props;
    const logoSize = qrSize < 128 ? qrSize / 3 : qrSize / 4;
    const logoMargin = qrSize < 128 ? qrSize / 3 : qrSize / 4 + qrSize / 8;

    return (
      <Segment basic className="notPaddedSegment">
        <div style={{ width: qrSize, float, position: 'inherit' }}>
          <QRCode value={window.location.href} level="H" size={qrSize} renderAs="svg" />
          {logoImagePath && (
            <Image
              src={logoImagePath}
              style={{
                height: logoSize + 'px',
                width: logoSize + 'px',
                position: 'absolute',
                left: logoMargin + 'px',
                top: logoMargin + 'px'
              }}
            />
          )}
        </div>

        {showTitle && (
          <Segment
            basic
            textAlign="center"
            className="notPaddedSegment"
            style={{ maxWidth: '220px' }}
          >
            <Header
              style={{
                height: '20px',
                margin: '5px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
              content={title}
              title={title}
            />
          </Segment>
        )}
      </Segment>
    );
  }
}

CurrentPageQR.defaultProps = {
  qrSize: 128,
  showTitle: true,
  showTitleInput: true,
  float: 'center'
};

export default CurrentPageQR;
